export const vendorCode = (id) => `VDR-${String(id).padStart(3, "0")}`;

export const vendorName = (vendor) => {
  if (!vendor) return "—";
  if (vendor.type === "Company") return vendor.company_name || "—";

  const primary = vendor.primary_users || {};
  const fullName = `${primary.first_name || ""} ${primary.last_name || ""}`.trim();
  return fullName || vendor.company_name || "—";
};